module.exports = __webpack_public_path__ + "img/yhwj.f03d76cb.png";